import { SearchQueryBuilder, SearchQueryOr, group } from "../query";
import { ClauseBuilder } from "./builder";
import { getFieldFromInnerClause, getQueryFromClause } from "./getter";
import { Clause } from "./model";
import {
  refineClauseWithInnerClause,
  refineClauseWithoutQuery,
} from "./refiner";

function getMergedQuery(firstClause: Clause, secondClause: Clause) {
  const firstQuery = getQueryFromClause(firstClause);
  const secondQuery = getQueryFromClause(secondClause);
  if (firstQuery === "") {
    return secondQuery;
  }
  if (secondQuery === "") {
    return firstQuery;
  }
  const queryBuilder = SearchQueryBuilder.getInstance();
  queryBuilder.add(
    SearchQueryOr.getInstance(group(firstQuery), group(secondQuery))
  );
  return queryBuilder.generateQuery();
}

export function mergeClauses(
  firstClause: Clause,
  secondClause: Clause,
  mergeQuery: boolean = false
) {
  if (mergeQuery) {
    const mergedQuery = getMergedQuery(firstClause, secondClause);
    const builder = ClauseBuilder.create(refineClauseWithoutQuery(firstClause));
    builder.merge(refineClauseWithoutQuery(secondClause));
    const clause = builder.toClause();
    if (mergedQuery === "") {
      return clause;
    }
    return refineClauseWithInnerClause(clause, {
      query: mergedQuery,
    });
  } else {
    const builder = ClauseBuilder.create(firstClause);
    builder.merge(secondClause);
    return builder.toClause();
  }
}

export function hardMergeClauses(newClause: Clause, previousClause: Clause) {
  const isNewClauseEmpty = !newClause;
  const isPrevClauseEmpty = !previousClause;
  if (isNewClauseEmpty && isPrevClauseEmpty) return { and: [] };
  if (isNewClauseEmpty) return previousClause;
  if (isPrevClauseEmpty) return newClause;
  const builder = ClauseBuilder.create(previousClause);
  newClause.and.forEach((innerClause) => {
    const field = getFieldFromInnerClause(innerClause);
    builder.removeField(field);
  });
  const cleanPrevClause = builder.toClause();
  return mergeClauses(newClause, cleanPrevClause);
}
